export default class LoginPasswordRequest {
    email: string = "";
    password: string  = "";
    institutionId: string = "";
}